import { Admins } from '../admins/Admins';
import { AutoPay } from '../autopay/AutoPay';
import { BillingAccounts } from '../billingAccounts/BillingAccounts';
import { MeterImages } from '../meterImages/MeterImages';
import { MeterReads } from '../meterReads/MeterReads';
import { PaymentReport } from '../uVPComponents/PaymentReport';
import { MeterRoutes } from '../routes/MeterRoutes';
import { ServiceAddresses } from '../serviceAddresses/ServiceAddresses';
import { withToast } from '../shared/Toast';
import { PaymentFlow } from '../uVPComponents/PaymentFlow';
import { UvpRecurring } from '../uVPComponents/UvpRecurring'; 
import { Wallet } from '../uVPComponents/Wallet';
import Home from './Home';
import { Reset } from './Reset';
import { ChargebackReturns } from '../uVPComponents/ChargebackReturns';
import { RecurringListing } from '../uVPComponents/RecurringListing';
import { BankReconciliation } from '../uVPComponents/BankReconciliation';
import { BillArchive } from '../uVPComponents/BillArchive';

const Routes = [
    {
        path: "/",
        name: "Home",
        Component: Home
    },
    {
        path: "/reset/:resetId",
        name: "Reset",
        Component: withToast(Reset)
    },
    {
        path: "/app/billing-accounts",
        name: "Billing Accounts",
        Component: withToast(BillingAccounts)
    },
    {
        path: "/app/service-addresses",
        name: "Service Addresses",
        Component: ServiceAddresses
    },
    {
        path: "/app/meter-reads",
        name: "Meter Reads",
        Component: MeterReads
    },
    {
        path: "/app/admins",
        name: "Admins",
        Component: Admins
    },
    {
        path: "/app/meter-routes",
        name: "Routes",
        Component: withToast(MeterRoutes)
    },
    {
        path: "/app/meter-images",
        name: "Meter Images",
        Component: withToast(MeterImages)
    },
    {
        path: "/app/autopay/",
        name: "Recurring Payments",
        Component: withToast(AutoPay)
    },
    {
        path: "/app/payment-flow",
        name: "Payment Flow",
        Component: withToast(PaymentFlow)
    },
    {
        path: "/app/Wallet",
        name: "Wallet",
        Component: withToast(Wallet)
    },
    {
        path: "/app/recurring",
        name: "Recurring",
        Component: withToast(UvpRecurring)
    },
    {
        path: "/app/payment-report",
        name: "Payment Report",
        Component: withToast(PaymentReport)
    },
    {
        path: "/app/returns",
        name: "Chargebacks/Returns",
        Component: withToast(ChargebackReturns)
    },
    {
        path: "/app/autopay-signups",
        name: "Autopay Signups Listing",
        Component: withToast(RecurringListing)
    },
    {
        path: "/app/bank-reconciliation",
        name: "Bank Reconciliation Report",
        Component: withToast(BankReconciliation)
    },
    {
        path: "/app/bill-archive",
        name: "Bill Archive",
        Component: withToast(BillArchive)
    }
]

export default Routes;